import { Box, Grid2 as Grid, Typography } from '@mui/material';
import type { FC } from 'react';
import { PortableText } from '~/components/atoms/PortableText';
import type { SanityLoyaltyTiers } from '~/types/sanity/loyalty';
import { getLoyaltyTier } from '~/utils/loyalty';
import { isPortableTextBlockArray } from '~/utils/portableTextUtils';

/**
 * Displays the given loyalty tiers in a column layout.
 */
export const LoyaltyTierColumns: FC<{ loyaltyTiersArray: SanityLoyaltyTiers['loyaltyTiersArray'] }> = ({
  loyaltyTiersArray,
}) => {
  return (
    <Grid container textAlign="left" spacing={4}>
      {loyaltyTiersArray.map(({ tier: tierId, tierBenefits: { text } }, index) => {
        const tier = getLoyaltyTier(tierId);

        if (!tier) {
          return null;
        }

        return (
          <Grid key={index} size={{ xs: 12, sm: 6 }}>
            <Box display="flex" alignItems="center" gap={3}>
              <Box
                alt={`Leafio Loyalty Tier - ${tier.image}`}
                component="img"
                height={42}
                src={tier.image}
                width={42}
              />
              <Box>
                <Typography variant="h6">{tier.name} Tier</Typography>
                <Typography variant="body1" fontWeight="bold">
                  {tier.minPoints.toLocaleString()} points
                </Typography>
              </Box>
            </Box>
            {isPortableTextBlockArray(text) && <PortableText portableText={text} />}
          </Grid>
        );
      })}
    </Grid>
  );
};
